module.exports = __webpack_public_path__ + "static/media/life.4565ff61.png";